import { useEffect, useState } from "react";
import { NotificationsPanelWrapper } from "./styles";
import { NotificationCard } from "../notification-card";
import { useNotification } from "../../../../../hooks/useNotifications";
import { useUpdatesAndNotifications } from "../../../../../hooks/useUpdatesAndNotifications";

interface INotificationPanelProps {}

export interface INotificationDStore {
	/** Um identificador para a notificação */
	id: number;
	/** Quem enviou a notificação? Aquisição ou Locação; */
	notification_origin_display: string;
	/** A mensagem da notificação */
	body: any;
	/** O link para onde a notificação deve redirecionar; Quando ausente, a notificação não exibe o "Ver mais" */
	link?: string;
	/** Se a notificação foi lida ou não; Quando true, não foi lida */
	unread: boolean;
	/**  */
	created?: Date;
}

export const NotificationsPanel: React.FC<INotificationPanelProps> = () => {
	/** Guarda as notificações não lidas pelo usuário
	 *
	 * todo - carregar as notificações do usuário e atualizar esse state
	 */
	const {
		notificationList,
		list,
		markReadNotification,
		markAllReadNotification,
	} = useUpdatesAndNotifications();

	/** Indica se o usuário tem ou não notificações não lidas
	 *
	 * Se tem, mostrar o botão de marcar todas como lidas
	 */
	const [hasUnreadNotifications, setHasUnreadNotifications] = useState(true);

	/** todo - marcar uma notificação como lida e remover da lista */
	const handleMarkAsRead = (id: number) => {
		markReadNotification(id);
	};

	/**  todo - marcar todas notificações como lidas */
	const handleMarkAllAsRead = () => {
		markAllReadNotification();
	};

	/** todo - redirecionar para todas as notificações */
	const handleSeeAll = () => {
		window.open("https://conta.dstoreconteudos.com.br/notifications", "_blank");
	};

	return (
		<NotificationsPanelWrapper>
			<div className="header">
				<span className="title">Notificações</span>

				{hasUnreadNotifications && (
					<button
						onClick={handleMarkAllAsRead}
						style={{ fontSize: 12 }}
					>
						Marcar todas como lidas
					</button>
				)}
			</div>

			<div className="notifications">
				{notificationList.map((notification) => (
					<NotificationCard
						key={notification.id}
						notification={notification}
						onDismiss={() => handleMarkAsRead(notification.id)}
					/>
				))}

				<button onClick={handleSeeAll}>
					Ver todas as notificações
				</button>
			</div>
		</NotificationsPanelWrapper>
	);
};
